import "./style.css";
import scrollToSection from "../scrollToSection";
import handIcon from "../../assets/svg/hand.svg";

export const ScrollToTop = ({ className }) => {
  return (
    <div
      className={`position-fixed scroll-to-top ${className ?? ""}`}
      onClick={() => scrollToSection("header")}
    >
      <img src={handIcon} alt="scroll to top" />
    </div>
  );
};
